import SetupMFAEnforced from './SetupMFAEnforced'

export default SetupMFAEnforced
